/**
 * Inclusive remaining days until the last open registration calendar day.
 * Example: last open day July 15
 *   July 1 => 15
 *   July 3 => 13
 */
export function daysUntilLastOpenDate(lastOpenYmd, now = new Date()) {
    if (!lastOpenYmd) return null;
    const match = String(lastOpenYmd).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) return null;

    const lastOpen = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const days = Math.round((lastOpen.getTime() - today.getTime()) / 86400000) + 1;
    return days >= 1 ? days : null;
}

/** Remaining days only while today is inside [start, lastOpen]. */
export function daysInActiveRegistrationWindow(startYmd, lastOpenYmd, now = new Date()) {
    if (!startYmd || !lastOpenYmd) return null;
    const startMatch = String(startYmd).match(/^(\d{4})-(\d{2})-(\d{2})/);
    const endMatch = String(lastOpenYmd).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!startMatch || !endMatch) return null;

    const start = new Date(Number(startMatch[1]), Number(startMatch[2]) - 1, Number(startMatch[3]));
    const lastOpen = new Date(Number(endMatch[1]), Number(endMatch[2]) - 1, Number(endMatch[3]));
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    if (today < start || today > lastOpen) return null;
    return daysUntilLastOpenDate(lastOpenYmd, now);
}

/**
 * Home banner number (client spec, MAY FINAL FINAL slide 21): days remaining until
 * registration ends. Shown only while a registration window is open; otherwise null,
 * and the banner keeps "NEW SEASON COMING SOON".
 * @param {{isRegistrationCountdownActive?: boolean, daysUntilRegistrationEnd?: number}} status homeBannerStatus data
 */
export function registrationEndCountdownDays(status) {
    if (!status || status.isRegistrationCountdownActive !== true) return null;
    const days = status.daysUntilRegistrationEnd;
    if (typeof days !== "number" || Number.isNaN(days)) return null;
    return days >= 1 ? days : null;
}

/** (Not used by the home banner any more.) Count down only if the season has not started yet. */
export function seasonStartCountdownDays(daysUntilSeasonStart) {
    if (typeof daysUntilSeasonStart !== "number" || Number.isNaN(daysUntilSeasonStart)) {
        return null;
    }
    return daysUntilSeasonStart >= 1 ? daysUntilSeasonStart : null;
}

export function readSelectedCityId() {
    try {
        const selectedCity = JSON.parse(localStorage.getItem("selectedCity"));
        return selectedCity?.id || null;
    } catch (e) {
        return null;
    }
}
